import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

import { initializeFaro } from "./observability/faro";

// ── breadcrumb from beforeUnload (hard reload while modal open) ──
if (sessionStorage.getItem("forceLogout") === "1") {
  sessionStorage.removeItem("forceLogout");
  window.location.replace("/logout");
}
import {
  IsAuthenticatedProvider,
  IpassLastUpdatedProvider,
  CsrfTokenProvider,
} from "auth";
import { ApolloClientProvider } from "graphql-client";
import AppLogout from "hooks/useApplogout";

initializeFaro();

ReactDOM.render(
  <React.StrictMode>
    <IsAuthenticatedProvider>
      <IpassLastUpdatedProvider>
        <CsrfTokenProvider>
          <ApolloClientProvider>
            <AppLogout>
              <App />
            </AppLogout>
          </ApolloClientProvider>
        </CsrfTokenProvider>
      </IpassLastUpdatedProvider>
    </IsAuthenticatedProvider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
